<template>
  <svg fill="none" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" :height="18" :width="18">
    <circle class="stroke-gold1" cx="5.5" cy="5.5" r="5" />
    <path class="stroke-gold1" d="M9 9L14 14" />
  </svg>
</template>

<script lang="ts" setup></script>
